export * from './mapExternalData';
